import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changeUserCity, changeUserToLocalStorage } from '../../services/user.service';
import { toast } from 'react-toastify';
import { toggleModal } from '../../redux/modal.slicer';
import ModalComponents from '../modal/Modal.Components';

const UserChangeCity = () => {
  const userStore = useSelector((state) => state.userStore.user); // Povlaci sacuvane podatke iz REDUX-a (folder redux)
  const [isLogged, setIsLogged] = useState(false);
  const [user, setUser] = useState(userStore);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userStore) {
      setIsLogged(true);
    } else {
      navigate('/');
    }
  }, [navigate, userStore]);

  const handleChangeName = (e) => {
    let inputValue = e.target.value;
    let copyUser = { ...user, city: inputValue };
    setUser(copyUser);
  };

  const onChangeSubmit = (e) => {
    e.preventDefault();
    if (!user.city) {
      return toast.error('Polje ne sme biti prazno.');
    }
    if (user.city.length < 3 || user.city.length > 50) {
      return toast.error('Polje mora imati od 3 do 50 karaktera');
    }
    changeUserCity({ user_id: user.user_id, city: user.city })
      .then((res) => {
        toast.success(res.data);
        changeUserToLocalStorage(user);
        navigate(`/user/${user.user_id}`);
        dispatch(toggleModal(false));
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err.response.data);
      });
  };

  return (
    <ModalComponents>
      {isLogged && (
        <div className="col-12 col-sm-6 m-auto my-3 text-start">
          <form onSubmit={onChangeSubmit}>
            <div className="mb-3">
              <label htmlFor="city" className="form-label">
                Promeni naziv mesta:
              </label>
              <input
                type="text"
                className="form-control"
                id="city"
                aria-describedby="city"
                placeholder='Beograd'
                defaultValue={userStore.city}
                onChange={(e) => handleChangeName(e)}
                minLength={3}
                maxLength={50}
              />
            </div>
            <button type="submit" className="btn btn-danger form-control">
              Izmeni
            </button>
          </form>
        </div>
      )}
    </ModalComponents>
  );
};

export default UserChangeCity;
